// extracted by mini-css-extract-plugin
module.exports = {"statusCard":"StatusCard_statusCard__1LUxg","statusCardSuccess":"StatusCard_statusCardSuccess__12AzU","statusCardError":"StatusCard_statusCardError__pPzbI"};